import React from 'react';
import { Table } from 'antd';
import { ColumnsType } from 'antd/es/table';

interface TableDataType {
    srno: number;
    category: string;
    dataIndex: string;
    [key: string]: any; // Allows dynamic year-based keys
}

interface IndicatorTableComponentProps {
    columns: ColumnsType<TableDataType>; // Change this line
    data: any[];
    loading?: boolean;
    pageSize: number;
    showSizeChanger: boolean;
    total: number;
    currentPage: number;
    onPageChange?: (page: number, pageSize: number) => void;
    pageSizeOptions?: number[];
    indicatorId: string;
}

const IndicatorTableComponent: React.FC<IndicatorTableComponentProps> = (props) => {
    const GetTableHeight = () => {
        return ['13', '16'].includes(props.indicatorId) ? 260 : 350;
    };

    return (
        <>
            <Table
                columns={props.columns}
                dataSource={props.data}
                loading={props?.loading || false}
                pagination={false}
                bordered={true}
                components={{
                    table: (props: any) => <table id="antd-table" {...props} />, // Custom table with an id
                }}
                rowKey={(record) => record.id}
                scroll={{ x: 'max-content', y: GetTableHeight() }}
            />
        </>
    );
};

export default IndicatorTableComponent;
